export default __webpack_public_path__ + "static/media/closeIcon.a045f878.svg";